import { render, staticRenderFns } from "./OTPModal.vue?vue&type=template&id=03a52c8d&scoped=true"
import script from "./OTPModal.vue?vue&type=script&lang=js"
export * from "./OTPModal.vue?vue&type=script&lang=js"
import style0 from "./OTPModal.vue?vue&type=style&index=0&id=03a52c8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a52c8d",
  null
  
)

export default component.exports